import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(advancedFormat);

export interface HistoryTimeLabels {
  minAgo: (count: number) => string;
  hrAgo: (count: number) => string;
  yesterday: string;
}

const MINUTES_PER_HOUR = 60;

export const formatHistoryTime = (
  updatedAtSeconds: number,
  labels: HistoryTimeLabels,
  nowMs: number = Date.now(),
): string => {
  const target = dayjs(updatedAtSeconds * 1000);
  const now = dayjs(nowMs);

  if (target.isSame(now, 'day')) {
    const minutes = Math.max(1, now.diff(target, 'minute'));

    if (minutes < MINUTES_PER_HOUR) {
      return labels.minAgo(minutes);
    }

    return labels.hrAgo(Math.floor(minutes / MINUTES_PER_HOUR));
  }

  const time = target.format('HH:mm');

  if (target.isSame(now.subtract(1, 'day'), 'day')) {
    return `${labels.yesterday} - ${time}`;
  }

  return `${target.format('ddd - MMM Do')} - ${time}`;
};
